import { zod4Resolver } from "mantine-form-zod-resolver"
import { z } from "zod"

import { FormFieldConfig } from "~/pages/Admin/components/TypesForm"

export const reactFormConfig = {
  validate: zod4Resolver(
    z.object({
      name: z.string(),
    })
  ),
  initialValues: {
    name: "",
  },
}

export const fields: FormFieldConfig[] = [
  {
    type: "text",
    name: "name",
    label: "Name",
    placeholder: "Activity Name",
  },
]
